import { DOCUMENT } from "@angular/common";
import { Inject, Injectable } from "@angular/core";
import { environment } from "../environments/environment";


@Injectable({
    providedIn : 'root'
})
export class SiteMapService {
    
 constructor(@Inject(DOCUMENT) private document: Document) {}

 setCanonicalURL(url: string) {
    let link: HTMLLinkElement | null= this.document.querySelector("link[rel='canonical']");

    if (link) {
      link.href = url;
    } else {
      link = this.document.createElement('link');
      link.setAttribute('rel', 'canonical');
      link.setAttribute('href', url);
      this.document.head.appendChild(link);
    }
  }

  setPaginationLinks(currentPage: number) {
    this.removeLinkTags(['prev', 'next']);

    if (currentPage > 1) {
      this.appendLinkTag('prev', `${environment.careOnlineWebUrl}jobs?page=${currentPage - 1}`);
    }

    const maxPage = 10;
    if (currentPage < maxPage) {
      this.appendLinkTag('next', `${environment.careOnlineWebUrl}jobs?page=${currentPage + 1}`);
    }
  }

  appendLinkTag(rel: string, href: string) {
    const link = this.document.createElement('link');
    link.setAttribute('rel', rel);
    link.setAttribute('href', href);
    this.document.head.appendChild(link);
  }

  removeLinkTags(rels: string[]) {
    rels.forEach(rel => {
      const el = this.document.querySelector(`link[rel='${rel}']`);
      if (el) {
        this.document.head.removeChild(el);
      }
    });
  }

}